// extracted by mini-css-extract-plugin
export default {"can_not_edit_text":"styles_can_not_edit_text__oUo9S","save_button":"styles_save_button__8p+C2","cardpadless":"styles_cardpadless__xkX3+"};